/**
 * Remote **development** backend (Azure). Use with: `ng serve --configuration=dev`
 * or `npm run start:dev`.
 *
 * Local backend: use default `ng serve` / `npm start` (see `environment.ts`).
 */
export const environment = {
  production: false,
  /** Backend API base URL (no trailing slash). */
  apiBaseUrl: 'https://dev-wapp-wus-backend-spice-001.azurewebsites.net',
  /** Path for token refresh on 401 (e.g. /api/v1/refresh). Response must include access_token or token. */
  refreshApiPath: '/api/v1/refresh',
  useMockRevenueCentersApi: false,
  useMockCompEstablishmentsApi: false,
  useMockValidateMenusApi: false,
  useMockAirportDetailsApi: false,
  /** When false, Find More calls POST /api/v1/establishment/search (visible in DevTools Network). */
  useMockDiscoverApi: false,
  azureAd: {
    enabled: true,
    clientId: '8ea56d1f-1536-45b9-a3df-9ed6f64af84f',
    tenantId: '8750a205-39f1-4690-97e3-956220a1108e',
    redirectUri: 'https://dev-wapp-wus-frontend-spice-001-e6djefacfnbbd6fc.westus-01.azurewebsites.net',
    loginScopes: ['User.Read'],
    apiScopes: []
  }
};
